const lineHeight = 26;

const styles = theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  tabsRoot: {
    borderBottom: '1px solid #e8e8e8',
    minHeight: lineHeight,
  },
  tabsIndicator: {
    backgroundColor: theme.palette.primary.light,
    height: '3px'
  },
  tabRoot: {
    // textTransform: 'none',
    minWidth: 50,
    minHeight: lineHeight,
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: 24,
    '&:hover': {
      color: theme.palette.primary.light,
      opacity: 1,
    },
    '&$tabSelected': {
      // color: theme.palette.primary.light,
      // fontWeight: theme.typography.fontWeightMedium,
    },
    '&:focus': {
      outline: 'none',
      // color: theme.palette.primary.light,
    }
  },
  labelContainer: {
    padding: '0px 2px',
  },
  label: {
    textTransform: 'none',
    fontFamily: 'Google Sans',
    fontSize: '14px',
  },
  wrapper: {
    marginBottom: 8
  },
  tabSelected: {},
  typography: {
    padding: theme.spacing.unit * 3,
  },
  buttonsFooter: {
    zIndex: '1000',
    position: 'relative',
    float: 'left',
    marginTop: 9
  },
  // footerLine: {
  //   marginTop: '10px',
  //   marginBottom: '5px'
  // },
  underline: {
    '&:after': {
      borderBottom: '1px solid #777',
    },
    '&&&&:hover:before': {
      borderBottom: '1px solid rgba(0, 0, 0, 0.42)'
    },
    '&:before': {
      borderBottom: '1px solid #ccc',
    },
    fontSize: 13,
    fontFamily: 'Open Sans',
    fontWeight: 400
  },
  button: {
    fontFamily: 'Google Sans',
    fontSize: 14,
    textTransform: 'none',
    fontWeight: 300,
    minHeight: 28,
    height: 28,
    '&:focus': {
      outline: 'none',
    },
    boxShadow: 'none',
    borderRadius: 3,
    lineHeight: '0em'
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/MaterialDashboardPro/Timeline/commentBlockStyle.js